import {Component, Input,  OnChanges, ChangeDetectorRef } from '@angular/core'
import { IUserReview } from 'src/app/interfaces'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    standalone: false
})
export class ReviewComponent implements OnChanges {
  equipmentProviderInActive: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef, 
    public sharedDataService: SharedDataService
    ) { 
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
  }

  @Input() reviews: IUserReview[] = []
  @Input() breakpoints: any = [{}]
  reviewsList: any = []
  reviewPage = 0

  fakeArray(length: number): any[]{
    return new Array(length)
  }

  ngOnChanges(){
    this.cdr.detectChanges()
  }

  getImagePath(index: number): string {
    return this.sharedDataService.assetsCdn(`images/trustpilot${index}.png`);
  }

  ngOnInit() {
     }
}
